import { getClient } from '../core/global-config.js';
import { createAndWaitTask } from '../core/index.js';

export interface VolcesSeededitSingleIpParams {
  /**
   * 编辑提示词，必填，建议长度约300个字符，最大500个字符
   */
  prompt: string;
  /**
   * Base64编码的图像数据数组，必须包含 exactly 1 个图像
   */
  binary_data_base64?: string[];
  /**
   * 图像URL数组，必须包含 exactly 1 个图像
   */
  image_urls?: string[];
  /**
   * 随机种子，-1或正整数，默认值为-1
   */
  seed?: number;
  /**
   * 是否使用改写器，默认值为true
   */
  use_rephraser?: boolean;
  /**
   * 输出图像宽度，范围512-2048，默认值为1328
   */
  width?: number;
  /**
   * 输出图像高度，范围512-2048，默认值为1328
   */
  height?: number;
}

export interface VolcesSeededitSingleIpResource {
  type: string;
  url: string;
  size?: number;
  jobId?: string;
  [key: string]: any;
}

/**
 * volces_seededit_single_ip
 *
 * 通过火山引擎SeedEdit Single IP API创建单图像编辑任务。[API Documentation](https://www.volcengine.com/docs/85128/1722713)
 *
 * @example
 * ```typescript
 * import { initSeacloud, volcesSeededitSingleIp } from 'seacloud-sdk';
 *
 * initSeacloud('your-api-key');
 *
 * const result = await volcesSeededitSingleIp({
 *   // 参数见 VolcesSeededitSingleIpParams 接口定义
 * });
 *
 * console.log(result); // 返回生成的资源列表
 * ```
 *
 * @param params 请求参数，详见 VolcesSeededitSingleIpParams 接口定义
 * @returns 生成的资源列表
 */
export async function volcesSeededitSingleIp(
  params: VolcesSeededitSingleIpParams,
): Promise<VolcesSeededitSingleIpResource[]> {
  const client = await getClient();

  const pollingOptions = {
    intervalMs: 3000,
    maxAttempts: 60,
  };

  const result = await createAndWaitTask(
    client,
    '/model/v1/generation',
    {
      model: 'volces_seededit_single_ip',
      input: [{ params }],
    },
    pollingOptions,
  );

  const resources: VolcesSeededitSingleIpResource[] = [];

  if (result.output) {
    for (const item of result.output) {
      if (item.content) {
        for (const resource of item.content) {
          resources.push({
            type: resource.type || 'unknown',
            url: resource.url || '',
            size: resource.size,
            jobId: resource.jobId,
            ...resource,
          });
        }
      }
    }
  }

  return resources;
}
